// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"start-shulte_wrapper__d6FdU","text":"start-shulte_text__3QvZu"};